import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store/store';
import Layout from './components/Layout/Layout';
import { setDefaultFavicon } from './utils/favicon';


// Pages
import Home from './pages/Home/Home';
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import AdminDashboard from './pages/Admin/Dashboard';
import OwnerDashboard from './pages/Owner/Dashboard';
import Orders from './pages/Owner/Orders';
import Customers from './pages/Owner/Customers';
import Menu from './pages/Owner/Menu';
import StoreSettings from './pages/Owner/StoreSettings';
import StorePage from './pages/Storefront/StorePage';
import CustomerOrders from './pages/Storefront/CustomerOrders';

// Styles
import './styles/variables.css';
import './styles/global.css';

function App() {
   useEffect(() => {
    setDefaultFavicon();
    document.title = 'Cafe.WebReady24 - Multi-Restaurant Food Ordering';
  }, []);
  return (
    <Provider store={store}>
      <Router>
        <Layout>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            
            {/* Storefront Routes */}
            <Route path="/:shopSlug" element={<StorePage />} />
            <Route path="/:shopSlug/orders" element={<CustomerOrders />} />
            
            {/* Admin Routes */}
            <Route path="/admin" element={<AdminDashboard />} />
            
            {/* Owner Routes */}
            <Route path="/owner" element={<OwnerDashboard />} />
            <Route path="/owner/orders" element={<Orders />} />
            <Route path="/owner/customers" element={<Customers />} />
            <Route path="/owner/menu" element={<Menu />} />
            <Route path="/owner/store" element={<StoreSettings />} />
            
            {/* 404 Route */}
            <Route path="*" element={
              <div className="container">
                <div className="card">
                  <div className="card-body text-center">
                    <h1>404 - Page Not Found</h1>
                    <p>The page you're looking for doesn't exist.</p>
                    <a href="/" className="btn btn-primary">Go Home</a>
                  </div>
                </div>
              </div>
            } />
          </Routes>
        </Layout>
      </Router>
    </Provider>
  );
}

export default App;